import * as effects from 'redux-saga/effects';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import { setAuthError } from '../NotificationBar/Actions';
import {
	login,
	loginError,
	loginSuccess,
	logout,
	logoutSuccess,
} from './Actions';
import { IUserActionTypes /*, initialUserInfo */ } from './Types';

function* handleLogin(action: ReturnType<typeof login>) {
	const backend = Backend.getInstance();

	try {
		// @ts-ignore
		const res = yield effects.apply(
			backend,
			backend.login,
			action.payload as any
		);

		Logger.info('Successfully logged in');
		let userInfo = res;
		yield effects.put(
			loginSuccess(
				userInfo.username,
				userInfo.group_id,
				userInfo.token,
				userInfo.expire_at,
				userInfo.authorization_info.user_info,
				userInfo.user_management_rights
			)
		);
		yield effects.put(setAuthError(null));
	} catch (err: any) {
		yield effects.put(setAuthError(err as Error));
		Logger.warn({ err }, 'Failed login');
		yield effects.put(loginError());
	}
}

function* handleLogout(action: ReturnType<typeof logout>) {
	const backend = Backend.getInstance();

	try {
		/*const res = */ yield effects.apply(backend, backend.logout, []);

		Logger.info('Successfully logged out');
		yield effects.put(logoutSuccess());
	} catch (err) {
		Logger.warn({ err }, 'Failed logout');
		yield effects.put(loginError());
	}
}

function* watchLogin() {
	yield effects.takeEvery(IUserActionTypes.LOGIN, handleLogin);
	yield effects.takeEvery(IUserActionTypes.LOGOUT, handleLogout);
}

export function* UserSaga() {
	yield effects.all([effects.fork(watchLogin)]);
}
